<template>
  <div>
    <h1 class="page-title">Notifications</h1>
    <AllNotifications />
  </div>
</template>

<script>
import AllNotifications from "@/components/organisms/AllNotifications";


export default {
  components: { AllNotifications },
  data() {
    return {
      loading: false,
      valid: false,
      dialog: {},
    };
  },
  methods: {
  },
};
</script>
